namespace Matrix.Data {
    export class ModelTargetColumns {
        static columnsKey = 'Data.ModelTarget';
    }
}
